/**
 * ARCHAT — API Admin (tenants, super_admin)
 * Solo UI — métodos se mezclan en apiService. NO modificar endpoints ni lógica.
 */

import { API_ENDPOINTS } from '../utils/constants';

/**
 * Métodos de administración de tenants (solo super_admin).
 * Se asignan a apiService vía Object.assign.
 */
export const apiAdminMethods = {
  async getAdminTenants() {
    return this.request(API_ENDPOINTS.ADMIN_TENANTS);
  },

  async getAdminTenantDetails(tenantId) {
    return this.request(`${API_ENDPOINTS.ADMIN_TENANT_DETAILS}?tenant_id=${tenantId}`);
  },

  async changeTenantPlan(tenantId, plan) {
    return this.request(API_ENDPOINTS.ADMIN_TENANTS, {
      method: 'POST',
      body: JSON.stringify({ action: 'change_plan', tenant_id: tenantId, plan })
    });
  },

  async suspendTenant(tenantId) {
    return this.request(API_ENDPOINTS.ADMIN_TENANTS, {
      method: 'POST',
      body: JSON.stringify({ action: 'suspend', tenant_id: tenantId })
    });
  },

  async reactivateTenant(tenantId) {
    return this.request(API_ENDPOINTS.ADMIN_TENANTS, {
      method: 'POST',
      body: JSON.stringify({ action: 'reactivate', tenant_id: tenantId })
    });
  }
};
